import React from 'react';
import ContentLoader from 'react-content-loader';

import { List, ListItem, Paper, Typography, WithStyles } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';
import { times } from 'lodash';

const styles = ({ spacing: { unit }, palette: { divider } }: Theme) => ({
  root: {
    background: 'white',
  },
  topLoaderWrapper: {
    width: 400,
  },
  contentLoaderWrapper: {
    width: '100%',
    borderTop: `1px solid ${divider}`,
    padding: unit,
    marginBottom: unit * 2,
  },
  contentLoader: {
    width: 800,
  },
});

interface ContentTableLoaderProps extends WithStyles<typeof styles> {
  isMobile?: boolean;
}

const ContentTableLoader: React.FC<ContentTableLoaderProps> = ({ classes, isMobile }) => (
  <List className={classes.root}>
    {times(3).map((blockLoaderIndex) => (
      <div key={`content-table-loader-${blockLoaderIndex}`}>
        <Typography variant="body1" color="primary" gutterBottom>
          &nbsp;
        </Typography>

        <Paper elevation={1} square>
          <ListItem alignItems="flex-start">
            <div className={classes.topLoaderWrapper}>
              <ContentLoader height={51} width={400} speed={3} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
                <rect x="39" y="6" rx="0" ry="0" width="284" height="20" />
                <rect x="39" y="37" rx="0" ry="0" width="230" height="11" />
                <circle cx="12" cy="24" r="12" />
              </ContentLoader>
            </div>
          </ListItem>
          {!isMobile && (
            <div className={classes.contentLoaderWrapper}>
              <div className={classes.contentLoader}>
                {times(blockLoaderIndex % 2 === 0 ? 5 : 4).map((contentLoaderIndex) => (
                  <ContentLoader
                    key={`content-loader-${blockLoaderIndex}-${contentLoaderIndex}`}
                    height={30}
                    width={600}
                    speed={3}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                  >
                    <rect x="62" y="10" rx="0" ry="0" width="100" height="14" />
                    {times(contentLoaderIndex % 2 === 0 ? 3 : 4).map((availabilityLoaderIndex) => (
                      <rect
                        key={`${blockLoaderIndex}-${contentLoaderIndex}-${availabilityLoaderIndex}`}
                        x={230 + 69 * availabilityLoaderIndex}
                        y="4"
                        rx="0"
                        ry="0"
                        width="62"
                        height="24"
                      />
                    ))}
                    <circle cx="36" cy="14" r="10" />
                  </ContentLoader>
                ))}
              </div>
            </div>
          )}
        </Paper>
      </div>
    ))}
  </List>
);

export default withStyles(styles)(ContentTableLoader);
